'use client';
import { FavoriteFilledIcon, FavoriteIcon, ShareIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useState } from 'react';
import { ImageAction } from '../../../../Buttons/ImageAction/ImageAction.mjs';
import { Image } from '../../../../DataDisplay/Image/Image.mjs';
import { factory } from '../../../../factory/factory.utils.mjs';
import { AspectRatioKeeper } from '../../../../Layout/AspectRatioKeeper/AspectRatioKeeper.mjs';
import { Flex } from '../../../../Layout/Flex/Flex.mjs';
import { Box } from '../../../../Other/Box/Box.mjs';
import { SharePopover } from '../../../../Popover/SharePopover/SharePopover.mjs';
import classes from './ProductCardImage.module.css.mjs';

const ProductCardImage = factory((props, ref) => {
  const { hasLink, href, image, onSave, isSaved, onShare, saveCTA, shareCTA, quickViewCTA, sharePopover } = props;
  const [isHovered, setIsHovered] = useState(false);
  const shouldAutoClose = sharePopover?.autoCloseOnParentHoverOut;
  return /* @__PURE__ */ React.createElement(
    AspectRatioKeeper,
    {
      aspectRatio: "1:1",
      className: classes.productCardImageWrapper,
      ref,
      onMouseEnter: shouldAutoClose ? () => setIsHovered(true) : void 0,
      onMouseLeave: shouldAutoClose ? () => setIsHovered(false) : void 0
    },
    /* @__PURE__ */ React.createElement(Box, { component: hasLink ? "a" : "figure", href, width: "100%" }, /* @__PURE__ */ React.createElement(Image, { ...image })),
    (onSave || onShare || saveCTA || shareCTA) && /* @__PURE__ */ React.createElement(Flex, { className: classes.productCardActions }, (saveCTA || onSave) && /* @__PURE__ */ React.createElement(
      ImageAction,
      {
        icon: isSaved ? FavoriteFilledIcon : FavoriteIcon,
        "aria-label": isSaved ? "remove from saved" : "add to favorite",
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onSave?.();
        },
        ...saveCTA
      }
    ), (shareCTA || onShare) && !sharePopover && /* @__PURE__ */ React.createElement(
      ImageAction,
      {
        icon: ShareIcon,
        "aria-label": "share product on social media",
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onShare?.();
        },
        ...shareCTA,
        className: clsx(classes.shareButton, shareCTA?.className)
      }
    ), shareCTA && sharePopover && /* @__PURE__ */ React.createElement(
      SharePopover,
      {
        target: /* @__PURE__ */ React.createElement(ImageAction, { icon: ShareIcon, "aria-label": "share product on social media", ...shareCTA, component: "div" }),
        withinPortal: false,
        withRoles: true,
        trapFocus: false,
        showDivider: !!(sharePopover.links && sharePopover.links?.length > 0 && (sharePopover.emailCTA || sharePopover.copyCTA)),
        width: "max-content",
        autoCloseOnParentHoverOut: shouldAutoClose,
        isParentHovered: shouldAutoClose ? isHovered : void 0,
        ...sharePopover,
        className: clsx(classes.shareButton, sharePopover?.className)
      }
    )),
    quickViewCTA && /* @__PURE__ */ React.createElement(
      ImageAction,
      {
        position: "absolute",
        className: classes.quickViewButton,
        label: "Quick View",
        ...quickViewCTA,
        onClick: (e) => {
          e.preventDefault();
          e.stopPropagation();
          quickViewCTA.onClick?.(e);
        }
      }
    )
  );
});

export { ProductCardImage };
